import Vue from 'vue';
import Hotjar from 'vue-hotjar';
import { IS_PRODUCTION_ENV, HOTJAR_SITE_ID } from '@/config';

Vue.use(Hotjar, {
    id: HOTJAR_SITE_ID,
    isProduction: IS_PRODUCTION_ENV,
});
